/** 百炼集成契约；只允许官方 HTTPS 地址，凭据明文只提交不回显。 */
import { z } from 'zod';

export const BAILIAN_REGIONS = [
  {
    id: 'cn-beijing',
    name: '中国大陆（北京）',
    base_url: 'https://dashscope.aliyuncs.com/compatible-mode/v1',
  },
  {
    id: 'ap-southeast-1',
    name: '新加坡',
    base_url: 'https://dashscope-intl.aliyuncs.com/compatible-mode/v1',
  },
  {
    id: 'cn-hongkong',
    name: '中国香港',
    base_url: 'https://cn-hongkong.dashscope.aliyuncs.com/compatible-mode/v1',
  },
  { id: 'us-east-1', name: '美国（弗吉尼亚）' },
  { id: 'eu-central-1', name: '德国（法兰克福）' },
  { id: 'ap-northeast-1', name: '日本（东京）' },
] as const;

export const BailianBaseUrlSchema = z
  .string()
  .trim()
  .max(512)
  .regex(
    /^https:\/\/(?:dashscope\.aliyuncs\.com|dashscope-intl\.aliyuncs\.com|cn-hongkong\.dashscope\.aliyuncs\.com|[a-z0-9][a-z0-9-]*\.(?:cn-beijing|ap-southeast-1|cn-hongkong|us-east-1|eu-central-1|ap-northeast-1)\.maas\.aliyuncs\.com)\/compatible-mode\/v1$/,
    '请输入百炼官方 HTTPS Base URL（以 /compatible-mode/v1 结尾）',
  );
export const UpsertBailianCredentialRequestSchema = z
  .object({
    api_key: z.string().trim().min(8).max(512).optional(),
    base_url: BailianBaseUrlSchema,
  })
  .strict();
export type UpsertBailianCredentialRequest = z.infer<typeof UpsertBailianCredentialRequestSchema>;
export type BailianCredentialResponse = {
  configured: boolean;
  key_tail: string | null;
  base_url: string | null;
  last_verified_at: string | null;
  updated_at: string | null;
};
